import { MyContext } from '../context/MyContext';
import React from 'react';
import SiteWrapper from '../SiteWrapper.react';

export function ParentSiteWrapper(props) {
    return (
        <MyContext.Consumer>
            {({ isLoggedIn }) => {
                return (
                    <SiteWrapper isLoggedIn={isLoggedIn}>
                        {props.children}
                    </SiteWrapper>
                );
            }}
        </MyContext.Consumer>
    );
}
